import type { FontFaceSpec } from '../../types';
import woff2 from '../src/PPMori-ExtraBoldNew.woff2';
import woff from '../src/PPMori-ExtraBoldNew.woff';

export const ppMoriExtraBold: FontFaceSpec = {
  weight: 800,
  style: 'normal',
  src: [
    { file: woff2, format: 'woff2' },
    { file: woff, format: 'woff' },
  ],
};
